<div class="paginationSec">
  <div class="recordblk">
    <ul class="recul">
      <li>
        <select class="recsel" [value]="itemsPerPage" (change)="onPageSizeChange($event)">
          <option [value]='5'>5</option>
          <option [value]="10">10</option>
          <option [value]="20">20</option>
          <option [value]="25">25</option>
          <option [value]="30">30</option>
        </select>
      </li>
      <li>Entries per page</li>
    </ul>
  </div>
  <div class="padinationBlk" [ngClass]="paginationType">
    <ul class="paginationul">
      <button (click)="gotToFirst()" [disabled]="currentPage === 1" class="gotToFirstBtn">
        <img src="assets/images/double-left-arrow.svg"
          class="{{currentPage === 1 ?'filter-light-gray':''}}" />
        </button>
      <button (click)="onPrevious()" [disabled]="currentPage === 1" class="onPreviousBtn">
        <img [src]="paginationType == 'type1' ? 'assets/images/left-arrow.svg' : 'assets/images/left-arrow-white.svg'"
          class="{{currentPage === 1 ?'filter-light-gray':''}}" />
        </button>
      <ng-container *ngFor="let page of getPages()">
        <li [class.active]="currentPage === page">
          <button (click)="onPageSelect(page)" class="page-item">
            <div class="pageItm">{{ page }}</div>
          </button>
        </li>
      </ng-container>
      <button (click)="onNext()" [disabled]="currentPage === totalPages" class="onNextBtn">
        <img [src]="paginationType == 'type1' ? 'assets/images/right-arrow.svg' : 'assets/images/right-arrow-white.svg'"
          class="{{currentPage === totalPages ?'filter-light-gray':''}}" />
        </button>
      <button (click)="gotToLast()" [disabled]="currentPage === totalPages" class="gotToLastBtn">
        <img
          src="assets/images/double-right-arrow.svg"
          class="{{currentPage === totalPages ?'filter-light-gray':''}}" />
        </button>
    </ul>
  </div>
</div>